// lbl.helpchat
export const helpchat = {
    title: "แบบสอบถามออนไลน์",
    help_code: "HELP CODE : ",
    open_date: "เฉพาะวันจันทร์ - ศุกร์ เวลา 08.30 - 17.00 น. เท่านั้น",

}
